export default __webpack_public_path__ + "static/media/TXT.be7e9de4.svg";